









































import DictMixin from '@/mixins/dict-mixin';
import { DatacollectDto } from '@/services/datacollect';
import { mixins } from 'vue-class-component';
import { Vue, Component, PropSync, Prop, Watch } from 'vue-property-decorator';

@Component
export default class DatacollectForm1 extends mixins(DictMixin) {
  @PropSync('formData') syncFormData!: DatacollectDto;
  @Prop() id!: any;

  @Watch('syncFormData.collectJobType')
  async jobTypechange() {
    
  }
}
